var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPlayLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 77,
    viewBox: "0 0 1200 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_4996)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1163.67 6.93767C1163.67 6.93767 1163.78 6.93767 1163.84 6.89348C1164.02 6.69462 1164.28 6.09807 1164.48 5.81084C1167.16 1.85589 1171.09 -0.309392 1175.97 0.684869C1179.31 1.3698 1182.16 3.77813 1183.61 6.82719C1189.92 20.1503 1172.48 29.9824 1164.7 37.6051C1164.17 38.0691 1163.34 38.0691 1162.81 37.6051C1158.86 34.0037 1154.6 30.7116 1150.73 27.0438C1145.68 22.2272 1141.24 16.8803 1143.02 9.34599C1145.37 -0.640812 1157.32 -2.784 1163.1 5.89922C1163.21 6.07597 1163.63 6.89348 1163.67 6.93767Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6915 9.67751H12.7837C12.5421 9.67751 11.6196 10.1857 11.3999 10.3845C9.4889 11.9533 10.7409 14.5162 10.1918 16.5269C9.75249 18.184 7.16056 18.0735 6.98483 16.0187C6.83107 14.3174 6.89697 11.7102 7.5779 10.1415C8.45652 8.17507 10.8288 6.3633 13.0254 6.3633H39.6915L36.0013 2.6072C34.8591 1.10476 36.7042 -0.927948 38.4395 0.508207C40.6361 2.29788 42.613 5.01552 44.7875 6.89357C45.4026 7.57851 45.4026 8.48439 44.7875 9.16933C42.613 11.0474 40.6361 13.765 38.4395 15.5547C36.7701 16.9246 34.8811 15.157 36.0013 13.4557L39.6915 9.6996V9.67751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5641 32.0595L16.2543 35.8156C17.3965 37.3181 15.5514 39.3508 13.8162 37.9146C11.6196 36.125 9.6427 33.4073 7.46811 31.5293C6.85308 30.8443 6.85308 29.9384 7.46811 29.2535C9.6427 27.3755 11.6196 24.6578 13.8162 22.8681C15.4855 21.4983 17.3746 23.2658 16.2543 24.9671L12.5641 28.7232H39.4939C39.7355 28.7232 40.6581 28.2151 40.8777 28.0162C42.7887 26.4475 41.5367 23.8845 42.0858 21.8739C42.5251 20.2168 45.1171 20.3272 45.2928 22.3821C45.4466 24.0833 45.3807 26.6905 44.6997 28.2592C43.8211 30.2257 41.4488 32.0374 39.2523 32.0374H12.5641V32.0595Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.588 65.3782H1200",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 65.3782H134.583",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.012 77C140.393 77 145.566 71.7967 145.566 65.3782C145.566 58.9596 140.393 53.7563 134.012 53.7563C127.631 53.7563 122.458 58.9596 122.458 65.3782C122.458 71.7967 127.631 77 134.012 77Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_4996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPlayLine);
export default __webpack_public_path__ + "static/media/landingPlayLine.60483c3604490429d94d08632e1b0af9.svg";
export { ForwardRef as ReactComponent };